import classNames from "classnames";
import { DComponent } from "../../../../../../components/DComponent";
import { getPriceText } from "../../../../../../utils/currency";
import { defer } from "../../../../../../utils/script";

export default class BankTransferModal extends DComponent {
  /** @constructs [content] */
  constructor({
    parent,
    id,
    qrCode = "",
    payAmount,
    payCurrency,
    content,
    bankName,
    accountNumber,
    accountName,
    branch,
    onContinue = () => { },
    onCancel = () => { },
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("BankTransferModal")
    }, true);
    this.qrCode = qrCode;
    this.payAmount = payAmount;
    this.payCurrency = payCurrency;
    this.content = content;
    this.bankName = bankName;
    this.accountNumber = accountNumber;
    this.accountName = accountName;
    this.branch = branch;
    this.onContinue = onContinue;
    this.onCancel = onCancel;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "BankTransferModal");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    this.fillData();
    $(".btn.btn-next", this.element).on("click", () => {
      this.isLoading(true);
      typeof this.onContinue == "function" && this.onContinue();
    });

    $(".btn.btn-cancel", this.element).on("click", () => {
      this.isLoading(false);
      typeof this.onCancel == "function" && this.onCancel();
    });
    this.element.on('hidden.bs.modal', () => {
      $("html, body").css("overflow", "auto");
    })

    this.element.on("hide.bs.modal", () => {
      $("html, body").css("overflow", "auto");
    })

    const clipboardSyntax = new window.Clipboard(".BankTransferModal .syntax .btn-copy", { container: this.element[0] });
    const clipboardAccountNumber = new window.Clipboard(".BankTransferModal .account-number .btn-copy", { container: this.element[0] });

    clipboardSyntax.on('success', onSucessCopy);
    clipboardSyntax.on('error', onErrorCopy);
    clipboardAccountNumber.on('success', onSucessCopy);
    clipboardAccountNumber.on('error', onErrorCopy);

    function onSucessCopy(e) {
      $(e.trigger).parent().attr("data-status", "copied");
      setTimeout(() => {
        $(e.trigger).parent().attr("data-status", "init");
      }, 3000);
    }
    function onErrorCopy(e) {
      $(e.trigger).parent().attr("data-status", "error");
      setTimeout(() => {
        $(e.trigger).parent().attr("data-status", "init");
      }, 3000);
    }
  }

  show() {
    $("html, body").css("overflow", "hidden");
    $(this.element).modal("show");
  }

  hide() {
    this.isLoading(false);
    $(this.element).modal("hide");
  }

  isShowing() {
    return $(this.element).hasClass("in") || $(this.element).hasClass("show");
  }

  isLoading(isLoad) {
    if (isLoad) {
      $(".btn-ok", this.element).addClass("loading");
    } else {
      $(".btn-ok", this.element).removeClass("loading");
    }
  }

  fillData() {
    if (this.qrCode) {
      $(".transfer-qrcode img", this.element).attr("src", this.qrCode);
      $(".transfer-qrcode", this.element).removeClass("hide");
    } else {
      $(".transfer-qrcode", this.element).addClass("hide");
    }

    if (this.payAmount !== undefined && this.payCurrency !== undefined) {
      $(".transfer-amount .value", this.element).html(this.genHtmlTotal(this.payAmount, this.payCurrency));
    }

    if (this.content !== undefined) {
      $(".syntax .value", this.element).text(this.content);
    }

    if (this.bankName !== undefined) {
      $(".bank-name .value", this.element).text(this.bankName);
    }

    if (this.accountNumber !== undefined) {
      $(".account-number .value", this.element).text(this.accountNumber);
    }

    if (this.accountName !== undefined) {
      $(".account-name .value", this.element).text(this.accountName);
    }

    if (this.branch !== undefined) {
      $(".branch .value", this.element).text(this.branch);
    }
  }

  /**
 * @param {BankTransferModal} _data - The text to repeat
 */

  updateData(_data) {
    defer(() => this.element, () => {
      Object.keys(_data).forEach(key => {
        this[key] = _data[key];
      });
      this.fillData();
    });
  }

  genHtmlTotal(payAmount, payCurrency) {
    return getPriceText(payAmount, payCurrency);
  }
}